import { useMemo } from "react";
import { getTimeZones, TimeZone } from "@vvo/tzdb";
import { makeTimezoneOptionFromTzdbTimezone } from "@core/features/timezones";
import { usePlatformStore } from "@platform/store";

/**
 * Platform-specific hook that gets the user's timezone option from the store.
 * Uses the core timezone utilities but wraps them with platform store access.
 */
export const useUserTimezoneOption = () => {
  const user = usePlatformStore((s) => s.user);

  return useMemo(() => {
    if (!user?.timezone) return null;

    const timezones = getTimeZones({ includeUtc: true });

    const foundTimezone = timezones.find((z) => {
      const isUtcGroup = z.name === "Etc/UTC" || z.group.includes("Etc/UTC");
      const value = isUtcGroup ? "UTC" : z.name;
      return value === user.timezone;
    });

    if (!foundTimezone) {
      return null;
    }

    return makeTimezoneOptionFromTzdbTimezone(foundTimezone as TimeZone);
  }, [user?.timezone]);
};

export default useUserTimezoneOption;
